// extracted by mini-css-extract-plugin
var _1 = "BirdviewEntityTitle-moduleinteractive__fDW0l";
var _2 = "BirdviewEntityTitle-modulenumber__P08mj";
var _3 = "BirdviewEntityTitle-moduletitle__Xt8FE";
export { _1 as "interactive", _2 as "number", _3 as "title" }
